import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getGrillingGuideLayout } from "./actions";

// Accessing the "banner" object

const DataStructure = {
  isLoading: false,
  isError: false,
  layout: {} as any,
  itemOrder: [] as any,
  selectedCat: ""
};

const GetGrillingGuideLayoutSlice = createSlice({
  name: "GrillingGuideLayout",
  initialState: DataStructure,
  reducers: {
    setUpdateSelectedCat: (state: any, action: PayloadAction) => {
      state.selectedCat = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGrillingGuideLayout.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getGrillingGuideLayout.fulfilled,
      (state, action: PayloadAction<any>) => {
        const layoutData =
          action.payload[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["container"];
        state.isLoading = false;
        state.isError = false;
        state.layout = layoutData?.[":items"]?.["grillingguide"];
        state.itemOrder = layoutData?.[":itemsOrder"];
      }
    );
    builder.addCase(getGrillingGuideLayout.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});
export const {setUpdateSelectedCat } = GetGrillingGuideLayoutSlice.actions;
export const getGrillingGuideLayoutSlice = GetGrillingGuideLayoutSlice.reducer;
